// adminViewMode.js — режим админ-просмотра: показывать в «Мои книги» ВСЕ книги
// из ссылки, включая уже заказанные. Включается параметром ?admin=1 в URL
// (например, в спец-ссылке из админки) и запоминается на сессию.

const KEY = "admin_view_mode";

export function isAdminViewMode() {
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.has("admin")) {
      const v = p.get("admin");
      if (v === "1" || v === "" || v === "true") {
        sessionStorage.setItem(KEY, "1");
        return true;
      }
    }
    return sessionStorage.getItem(KEY) === "1";
  } catch (e) {
    return false;
  }
}

export function enableAdminViewMode() {
  try {
    sessionStorage.setItem(KEY, "1");
  } catch (e) {}
}